<template>
  <b-table
    :columns="columns"
    :data="statements"
  />
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          field: 'code',
          label: 'Code'
        },
        {
          field: 'phrase',
          label: 'Phrase'
        }
      ]
    }
  },
  props: {
    statements: {
      type: Array,
      required: true
    }
  }
}
</script>
